'use client'

import { useContext } from 'react'
import { menu } from './constants'
import { AuthContext, Dropdown } from '@wolfdanepug/common-react'
import { useLogout } from '../../lib/useLogout'
import { useNavigate } from 'react-router'

export default function AccountDropdown() {
	const { useContextUser } = useContext(AuthContext)
	const user: any = useContextUser()
	const logout = useLogout()
	const navigate = useNavigate()

	const handleClick = (config: any) => {
		switch (config.event) {
			case 'settings':
				navigate('/settings')
				break
			case 'sign-out':
				logout()
				break
		}
	}

	if (!user) {
		return null
	}

	return (
		<Dropdown
			items={menu}
			name={`${user?.firstName} ${user?.lastName}`}
			onClick={handleClick}
			tooltip="My Account"
			sx={{
				menu: { mt: '75px' }
			}}
		/>
	)
}
